import RelatedCoursesModule from './containers/relatedCoursesModule'

export {default as RelatedCoursesModuleLayout} from './components/relatedCoursesModuleLayout'

export default RelatedCoursesModule
